export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";